import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import SALink from 'components/SALink'
import styles from './AASection.module.scss'
import Avatar from 'components/SA/Avatar'
import { getCurator } from '../../selectors/general'
import useQA from 'hooks/useQA'

const AASection: FC = () => {
  const curator = useSelector(getCurator)
  const { name, title, image } = curator
  const { testId } = useQA()
  return (
    <div className={styles.aaSection} {...testId('aaSection')}>
      <div className={styles.aaSectionRow}>
        <div className={styles.textSection}>
          <h3 className={styles.title}>Complimentary Art Advisory</h3>
          <p className={styles.description}>
            Our free art advisory service pairs you with a knowledgeable curator who will guide you
            through a seamless, stress-free process to find artwork that fits your style and needs.
          </p>
          <SALink href='/artadvisory' title='Work with a curator'>
            <div className={styles.contactButton} {...testId('contact-button')}>
              <p className={styles.buttonText}>Work with a curator</p>
            </div>
          </SALink>
        </div>
        <div className={styles.imageSection}>
          <h3 className={styles.mobileTitle}>Complimentary Art Advisory</h3>
          <div className={styles.imageAndName}>
            <div className={styles.image}>
              <Avatar
                width='236'
                height='236'
                image={image}
                shape='round'
                styleOverride={styles.curatorAvatar}
                alt={`Curator - ${name}`}
              />
            </div>
            <div className={styles.bio} {...testId('curator-bio')}>
              <p className={styles.name}>{`${name}, ${title}`}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AASection
